import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import WidgetTemplate from './Template'

const FooterControl = (props) => {
  return <WidgetTemplate props={props} layout="footer" />
}

export const footerControlTester = rankWith(3, scopeEndsWith('footer'))

export default withJsonFormsControlProps(FooterControl)
